import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LANGUAGE_IMAGE_PATH } from './constants';
import styles from './LanguagePanel.module.scss';
/**
 * Panel component that displays available language options with flags and names.
 * Handles language selection and uses panelRef for click-outside detection.
 */
export const LanguagePanel = ({ handleLanguageChange, languageOptions, panelRef, setOpen, }) => {
    if (!languageOptions)
        return null;
    /**
     * Handles language selection and closes the panel.
     */
    const selectLanguage = (language) => {
        setOpen(false);
        handleLanguageChange(language);
    };
    return (_jsx("div", { ref: panelRef, className: styles.languagePanel, children: languageOptions.map((language) => (_jsxs("button", { className: styles.languageOption, onClick: () => selectLanguage(language.value), type: "button", children: [_jsx("img", { src: `${LANGUAGE_IMAGE_PATH}/flags/${language.value}.svg`, alt: "", className: styles.languageFlag }), _jsx("span", { className: styles.languageName, children: language.name })] }, language.value))) }));
};
